import { BodyText } from '@paypalcorp/pp-react'
import { merge } from 'lodash-es'
import PageMessage from 'ppbl/components/PageMessage'
import { useApplicationContext } from 'ppbl/hooks'
import clientLogger from 'ppbl/utils/client-logger'
import { redirectToServerRoute } from 'ppbl/utils/common-utils'
import { CaseTypes } from 'ppbl/utils/constants'
import { trackClick, trackPage } from 'ppbl/utils/fpti-helper'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import React, { useEffect } from 'react'
import { getPortalUrl, getRenewalStatus } from '../__utils__'

const fptiData = {
  page: 'errorPage',
}

type Props = {
  applicationType: string
}

const ErrorPage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()
  const portalInfo = data?.applicationMetaData?.portalAccess

  useEffect(() => {
    clientLogger.info(
      'Error page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
  }, [])

  const onclick = () => {
    if (getRenewalStatus(applicationType) === 'LOAN_RENEWAL') {
      trackClick(
        merge(fptiData, {
          component: 'continueToPortal_button',
          link: 'continueToPortal_button',
          applicationId: data?.applicationMetaData?.applicationId,
        }),
      )
      const portalUrl = getPortalUrl(portalInfo, CaseTypes.CREDIT_BUREAU_FROZEN)
      window.open(portalUrl)
    } else {
      trackClick(
        merge(fptiData, {
          component: 'restartApplication_button',
          link: 'restartApplication_button',
          applicationId: data?.applicationMetaData?.applicationId,
        }),
      )
      redirectToServerRoute(
        `/merchant-lending/loanbuilder/${applicationType}/start`,
      )
    }
  }

  return (
    <PageMessage
      type="error"
      onPrimaryAction={onclick}
      localization={{
        title: getLocalizedText('error-page.title'),
        primaryText: getLocalizedText('error-page.restartButton'),
      }}
    >
      <BodyText className="body__text">
        {getLocalizedText('error-page.bodyText')}
      </BodyText>
    </PageMessage>
  )
}

export default ErrorPage
